<template>
  <div class="applyHomePage" v-loading="loading">
    <backgroundTop title="遵义医科大学附属医院"></backgroundTop>
    <div class="container">
      <el-card>
        <!-- 报名信息 -->
        <div class="tableTile"><span class="title">报名信息</span></div>
        <el-table :data="reportInfo" border style="width: 100%">
          <el-table-column prop="type_name" label="报名信息" width="1018"></el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button type="success" @click="OnApply(scope.row)">进入报名</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-divider></el-divider>
        <!-- 我参与的报名 -->
        <div class="tableTile"><span class="title">我参与的报名</span></div>
        <el-table :data="info" border style="width: 100%">
          <el-table-column prop="public_time" label="报名时间" width="110"> </el-table-column>
          <el-table-column prop="type_name" label="报名信息" width="400"></el-table-column>
          <el-table-column prop="signup_job" label="报名职位" width="150"> </el-table-column>
          <el-table-column prop="rec_id" label="报名编号" width="80"> </el-table-column>
          <el-table-column prop="regular" label="编制类型" width="80"> </el-table-column>
          <el-table-column prop="signup_status_msg" label="当前状态" width="200"> </el-table-column>
          <el-table-column label="操作" width="141">
            <template slot-scope="scope">
              <el-button type="success" v-if="scope.row.signup_status_code == 210"
                @click="checkFormHandle(scope.$index, scope.row)">查看报名表</el-button>
              <el-button type="success" v-if="scope.row.signup_status_code == 211"
                @click="activeSure(scope.$index, scope.row)">前往缴费</el-button>
              <el-button type="danger" v-if="scope.row.signup_status_code == 212"
                @click="updataFormHandle(scope.$index, scope.row)">查看失败原因</el-button>
              <el-button type="success" v-if="scope.row.signup_status_code == 221"
                @click="activeSure(scope.$index, scope.row)">等待打印准考证</el-button>
              <el-button type="danger" v-if="scope.row.signup_status_code == 222"
                @click="activeSure(scope.$index, scope.row)">查看失败原因</el-button>
              <el-button type="success" v-if="scope.row.signup_status_code == 230"
                @click="cardHandle(scope.$index, scope.row)">查看准考证</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div style="height: 8vh;" class="bottom-div"></div>
    <CopyRight />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import backgroundTop from '../components/backgroundTop'
import CopyRight from '../components/CopyRight'
export default {
  name: 'ApplyHome',
  components: {
    backgroundTop,
    CopyRight
  },
  data() {
    return {
      loading: true,
      reportInfo: [
        {
          signup_id: '',
          type_name: ''
        }
      ],
      info: [
        {
          signup_id: '',
          public_time: '',
          type_name: '',
          regular: '',
          signup_job: '',
          signup_status_msg: '',
          signup_status_code: ''
        }
      ]
    }
  },
  created() {
    this.getMySignupList()
    this.getSignupList()
  },
  methods: {
    ...mapMutations({
      setRegistration: 'SET_REGISTRATION',
      setRecID: "SET_RECID"
    }),
    // 获取当前报名信息Api
    async getMySignupList() {
      const { data: res } = await this.$axios.get('/api/signup/mySignupList')
      console.log(res)
      this.loading = false
      if (res.response_code == 200) {
        console.log("si", res.data)
        this.info = res.data
        this.info.forEach((item, index) => {
          if (item.signup_status_code == 212) {
            this.info[index].signup_status_msg = '未通过审核'
          }
          if (item.signup_status_code == 222) {
            this.info[index].signup_status_msg = '未通过复审'
          }
        })
      }
    },
    // 报名信息Api
    async getSignupList() {
      const { data: res } = await this.$axios.get('api/signup/signupList')
      console.log(res)
      if (res.response_code !== 200) return false
      this.reportInfo = res.data
    },
    // 点击相应报名信息进入报名
    OnApply(val) {
      console.log(JSON.stringify(val))
      const registration = JSON.stringify(val)
      this.setRegistration(registration)
      this.$router.push('/ApplyPromise')
    },
    updataFormHandle(ind, row) {
      console.log(row)
      // console.log('aaaaaaa')
      this.setRecID(row.rec_id)
      this.$router.push({
        path: '/Apply',
        query: { singupId: row.signup_id, bianzhi: row.regular }
      })
    },
    activeSure(ind, row) {
      // alert('进入缴费页面')
      this.$router.push({
        path: '/Apply',
        query: { singupId: row.signup_id, bianzhi: row.regular }
      })
    },
    cardHandle(ind, row) {
      this.$router.push({
        path: '/Apply',
        query: { singupId: row.signup_id, bianzhi: row.regular }
      })
    },
    checkFormHandle(ind, row) {
      this.setRecID(row.rec_id)
      this.$router.push({
        path: '/Apply',
        query: { singupId: row.signup_id, bianzhi: row.regular }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';

.applyHomePage {
  .container {
    min-height: calc(100vh - 180px)
  }

  .el-card {
    @include autoInner();
  }

  .apply {
    display: flex;
    justify-content: space-between;
  }

  .tableTile {
    margin-bottom: 15px;
    font-size: 24px;
  }
}</style>
